import { data } from '@/config/data'
import {
  slideNames,
  formNames,
  hiddenInputs,
  formTypes,
  messages,
  propertyTypes
} from '@/config/enums'

export default {
  // DATA SLIDES
  slides: data,

  // ENUMS
  slideNames,
  formNames,
  formTypes,
  messages,
  propertyTypes,
  // enum object
  // using in button next to check honeypot input
  hiddenInputs,

  // OTHER
  el: null,
  currentSlide: 0,
  propertyType: '',
  hausType: 0,
  immobilienwert: 500000, // property value
  wunschbetrag: 100000, // desired amount
  wunschbetragMax: 250000, // desired amount max
  // array for rendering inputs
  hiddenInputsArray: insertInputs(hiddenInputs),
  salesforce: insertFormInfo(hiddenInputs, formNames),
  calculator_variant: 1,
  inputValidate: false,
  // because email checkbox needs to be aware of
  otherAddressCheckbox: false,
  // desigin
  design: null,
  // tag manager
  tagVariant: ''
}

// HELPERS
function insertFormInfo(obj_1, obj_2) {
  let arr = []

  for (const key in obj_1) {
    if (obj_1[key].send !== false) {
      arr.push({
        name: obj_1[key].name,
        form_name: obj_1[key].form_name,
        value: obj_1[key].value,
        mandatory: obj_1[key].mandatory
      })
    }
  }
  for (const key in obj_2) {
    // check if exists in array
    let hasName = false
    arr.forEach(a => {
      if (a.name === obj_2[key].name) {
        hasName = true
      }
    })
    // if no
    if (!hasName) {
      if (obj_2[key].send !== false) {
        arr.push({
          title: obj_2[key].title,
          name: obj_2[key].name,
          value: obj_2[key].value
        })
      }
    }
  }

  return arr
}

function insertInputs(obj) {
  let arr = []

  for (const key in obj) {
    if (obj[key].send !== false) {
      arr.push({
        name: obj[key].name,
        form_name: obj[key].form_name,
        value: obj[key].value,
        wrap: obj[key].wrap,
        type: obj[key].type,
        id: obj[key].id
      })
    }
  }

  return arr
}
